import { Icon } from '@components';
import { Button, Flex, theme, Typography } from '@styles';
import { ReactComponent as LinkIcon } from '@svgs/link.svg';
import { func } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { sideNavigationProps } from './SideNavigation.layoutProps';

const SideNavigation = ({
  // checkNotifications,
  onNavigationButtonClick,
}) => {
  const { i18n } = useTranslation();

  const { activitiesSideContentState } = useSelector(
    (state) => state.activitiesSlice
  );

  const sideNavigationElements = sideNavigationProps.map(
    (navigationButton, index) => (
      <Button
        key={`${navigationButton.id}-${navigationButton.titleText}`}
        height={45}
        onClick={onNavigationButtonClick(navigationButton.id)}
        px={24}
        variant={
          navigationButton.id === activitiesSideContentState
            ? 'primary'
            : 'secondary'
        }
        whiteSpace="nowrap"
        width="fit-content"
        {...((index === 0 || index === sideNavigationProps.length - 2) && {
          mb: 20,
        })}
        position="relative"
      >
        {/* {checkNotifications(navigationButton.type) && (
          <Flex
            backgroundColor={theme.colors.schoolBusYellow[100]}
            border={`0.5px solid ${theme.colors.black[100]}`}
            borderRadius={6}
            height={11}
            position="absolute"
            right={-4}
            top={0}
            width={11}
            zIndex={100}
          />
        )} */}
        <Typography
          color={
            navigationButton.id === activitiesSideContentState
              ? theme.colors.black[100]
              : theme.colors.white[100]
          }
          display="inline"
          variant={
            navigationButton.id === activitiesSideContentState
              ? 'MS-bold-s16-lh25'
              : 'MS-semibold-s16-lh25'
          }
        >
          {i18n.t(navigationButton.titleText).toUpperCase()}
        </Typography>
        {navigationButton.id === 'seeMore' && (
          <Icon
            color={
              navigationButton.id === activitiesSideContentState
                ? theme.colors.black[100]
                : theme.colors.white[100]
            }
            ml={3}
            SVG={LinkIcon}
          />
        )}
      </Button>
    )
  );

  return (
    <Flex flexDirection="column" gap={28} mb={32}>
      {sideNavigationElements}
    </Flex>
  );
};

SideNavigation.propTypes = {
  checkNotifications: func.isRequired,
  onNavigationButtonClick: func.isRequired,
};

export default SideNavigation;
